import { Component, Inject, Injectable, Input, OnInit } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { AccionAnualModel } from 'src/app/model/FaseAnual.model';
import { FaseAnualSeguimientoComponent } from '../fase-anual-seguimiento.component';

@Component({
  selector: 'app-accion-anual-seguimiento',
  templateUrl: './accion-anual-seguimiento.component.html',
  styleUrls: ['./accion-anual-seguimiento.component.css']
})

export class AccionAnualSeguimientoComponent implements OnInit {

  @Input() accionData : AccionAnualModel;
  @Input() readonly : boolean;
  fechaValida : boolean = false;
  fechaClass : string = "input-fecha";

  fechaInicio : any;
  fechaFin : any;

  constructor(
    @Inject(FaseAnualSeguimientoComponent) private parent: FaseAnualSeguimientoComponent,
  ) { }

  ngOnInit(): void {
    this.cargaInicial()
  }

  cargaInicial(){
    var fechaInicioMedicion =  this.accionData.fechaInicioMedicion ? new Date(this.accionData.fechaInicioMedicion) : null;
    var fechaFinMedicion =  this.accionData.fechaFinMedicion ? new Date(this.accionData.fechaFinMedicion) : null;
    if (fechaFinMedicion != null && fechaInicioMedicion != null) {
      this.fechaInicio  = {"year": fechaInicioMedicion.getFullYear(),"month": fechaInicioMedicion.getMonth() + 1, "day": fechaInicioMedicion.getDate()};
      this.fechaFin  = {"year": fechaFinMedicion.getFullYear(),"month": fechaFinMedicion.getMonth() + 1, "day": fechaFinMedicion.getDate()};
      this.validarFechas();
    }
  }

  change(){
    this.parent.cambios = true;
    this.validarFechas();
  }

  validarFechas(){
    this.fechaClass = "input-fecha-error";
    this.fechaValida = false;
    if( this.fechaInicio != undefined && this.fechaFin != undefined  && this.fechaInicio != null && this.fechaFin != null){

      var fechaInicioMedicion = new Date(this.fechaInicio.year, this.fechaInicio.month -1, this.fechaInicio.day);
      var fechaFinMedicion = new Date(this.fechaFin.year, this.fechaFin.month -1 , this.fechaFin.day);

      this.accionData.fechaInicioMedicion = fechaInicioMedicion;
      this.accionData.fechaFinMedicion = fechaFinMedicion;

      if (fechaFinMedicion.getTime() - fechaInicioMedicion.getTime() >= 86400000) {
        this.fechaValida = true;
        this.fechaClass = "input-fecha";
      } else {
        this.fechaClass = "input-fecha-error";
        this.fechaValida = false;
      }
    } else {
      this.fechaClass =  "input-fecha-error";
      this.fechaValida = false;
    }
  }
}

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {

  readonly DELIMITER = '-';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day : parseInt(date[0], 10),
        month : parseInt(date[1], 10),
        year : parseInt(date[2], 10)
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : '';
  }
}